export const FULLYEARINMS: number = 31_556_952_000;
export const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;